import { render } from "./MainThanhToanThongMinh.vue?vue&type=template&id=e4a56e8e"
import script from "./MainThanhToanThongMinh.vue?vue&type=script&lang=js"
export * from "./MainThanhToanThongMinh.vue?vue&type=script&lang=js"

import "./MainThanhToanThongMinh.vue?vue&type=style&index=0&id=e4a56e8e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__